export default {
  viewButton: 'View order cart',
  tabs: {
    newOrder: 'New Order',
    newClaim: 'New Claim',
  },
  order: 'Order',
  claim: 'Claim',
  addSelectedSiteItemsToCart: {
    toast: {
      error: {
        title: 'Error',
        content: 'All selected items are already in the cart.',
      },
    },
  },
  invalidQty: 'Qty must be more than 0',
  quantityErrorToast: {
    title: 'Invalid quantity',
    content: 'Please ensure quantity is greater than zero',
  },
  orderDetailsSection: {
    title: '{type} Details',
    subTitle: 'Complete the {type} details below',
  },
  orderInventorySection: {
    title: '{type} Inventory',
    subTitle:
      'Individual {type}s will be placed for the below items at each of the included vendors',
  },
  form: {
    fieldNames: {
      siteName: 'Site Name',
      deliveryDate: 'Delivery Date',
      notes: 'Notes',
    },
    placeholders: {
      siteName: 'Enter site name',
      deliveryDate: 'Select delivery date',
      notes: 'Add any notes here',
    },
    validations: {
      required: {
        siteName: 'Site name is required',
      },
    },
  },
  table: {
    removeTooltip: 'Remove item',
    buttons: {
      create: 'Create order request(s)',
      clear: 'Clear cart',
      deny: 'Deny',
      approve: 'Approve',
    },
    variation: 'Variation - Value changed',
    columns: {
      itemName: 'Item Name',
      specification: 'Spec',
      sku: 'SKU',
      vendor: 'Vendor',
      unit: 'Unit',
      quantity: 'Quantity',
      rate: 'Rate',
      total: 'Total',
      ordered: 'Ordered',
      boq: 'BOQ',
      none: '',
    },
    rows: {
      total: 'Delivered Total',
      orderSubtotal: 'Order Subtotal',
      orderTotalExclVAT: 'Total Excl VAT',
      orderTotalInclVAT: 'Total Incl VAT',
      vatTotal: 'VAT Total',
      pendingVariationsTotal: 'Pending Variations Total (Incl VAT)',
      inclVat: 'Total Incl VAT',
      vatByLine: 'VAT registered vendors will have their VAT % added to their total price',
      variationError: 'BOQ already has a pending variation, please approve or deny it first.',
    },
    dialog: {
      variation: {
        title: '{action} variation',
        body: 'Are you sure you want to {action} this variation?',
      },
      delete: {
        title: 'Delete {name} from cart',
        body: 'Are you sure you want to delete {name} from the cart?',
      },
    },
  },
  createOrder: {
    toast: {
      title: 'Orders created',
      content: 'All orders have been successfully created, pending approval.',
    },
    modal: {
      title: 'Create orders',
      body: 'The following order requests will be created.',
      subBody: 'Please confirm and add deposit amounts should they be required.',
      table: {
        headers: {
          vendor: 'Vendor',
          amount: 'Amount',
          deposits: 'Deposits',
        },
        buttons: {
          addDeposit: 'Add deposit amount',
        },
      },
    },
    labels: {
      assignee: 'Assignee',
      dueDate: 'Due date',
      selectDate: 'Select date',
      noMethod: 'No method set',
      paymentMethod: 'Payment method',
      paymentType: 'Payment type',
      paymentDue: 'Payment due',
      retention: 'Retention',
      deposit: 'Deposit',
      addition: 'Addition',
      paymentAssignee: 'Assign payment (optional)',
      documentation: 'Docs',
    },
    documentationDrawer: {
      title: 'Order Documentation',
      accordionTitle: 'Key documentation',
      accordionSubtitle:
        'All documents required for the completion of this order and its associated payments.',
      infoMessage:
        'These documents are optional at creation. You can also upload them later from the order detail page on an individual order.',
      orderPrerequisites: {
        title: 'Order prerequisites',
        documents: ['Quote/Proforma Invoice', 'Tax Invoice'],
        documentHint: `PDF, JPG or PNG · up to 10MB per file · Multiple files supported`,
      },
    },
    emptyPaymentMethod: {
      message: 'No payment method found for this vendor. Please edit their details to add one.',
      buttonText: 'Edit Vendor Details',
    },
  },
  bulkAddToCart: {
    successToastTitle: 'Multiple items added',
    successToastBody: 'Multiple items have been added to your cart successfully',
    errorToastTitle: 'Error',
    errorToastBody: 'Failed to add items to cart',
    nothingAddedToastTitle: 'Nothing added to the cart',
    partlyAddedToastTitle: 'Some lines were not added',
    skippedToastBody:
      "Lines {lines} can't be ordered: their item is no longer available, or they have a pending variation.",
  },
};
